export default __webpack_public_path__ + "static/bentoSectionBg5Mob-2ad62e9210b6554a6adc203728fa5e46.webp";